(function () {
    'use strict';

    function crmController() {
        var vm = this;
        vm.getWorkflowsUrl = function(entityId) {
            return "[BuildifyApiHost]/api/" + entityId + "/workflows";
        }

        vm.getSharedWorkflowsUrl = function(entityId) {
            return "[BuildifyApiHost]/api/" + entityId + "/workflowsharingconnections";
        }

        vm.getRfpsUrl = function(entityId) {
            return "[BuildifyApiHost]/api/" + entityId + "/requestforproposals";
        }

        vm.getRfpResponsesUrl = function(entityId) {
            return "[BuildifyApiHost]/api/" + entityId + "/requestforproposalresponses";
        }
    }

    crmController.$inject = [];

    angular.module('ecap.crm').controller('crmController', crmController);
})();
